module.exports = __webpack_public_path__ + "img/facebook.efdb3bb4.png";